var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_1308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4066 0H2.59337C1.16114 0 0 1.16114 0 2.59337V21.4066C0 22.8389 1.16114 24 2.59337 24H21.4066C22.8389 24 24 22.8389 24 21.4066V2.59337C24 1.16114 22.8389 0 21.4066 0ZM19.4032 10.4549C17.8839 10.4549 16.476 9.96894 15.3266 9.14397V15.0981C15.3266 18.0721 12.9074 20.4913 9.93383 20.4913C8.78486 20.4913 7.71923 20.1289 6.84323 19.5137C5.45267 18.5375 4.54108 16.9227 4.54108 15.0981C4.54108 12.1245 6.96028 9.70534 9.93383 9.70534C10.1806 9.70534 10.4226 9.72548 10.6605 9.75778V12.7491C10.4306 12.677 10.1871 12.6353 9.93383 12.6353C8.57557 12.6353 7.47109 13.7403 7.47109 15.0981C7.47109 16.0439 8.00718 16.8655 8.79142 17.278C9.1332 17.4583 9.52134 17.5613 9.93383 17.5613C11.2607 17.5613 12.3427 16.506 12.3919 15.1908L12.3966 3.44877H15.3266C15.3266 3.70254 15.3514 3.95068 15.3959 4.19181C15.6028 5.30847 16.2653 6.26594 17.183 6.86477C17.8225 7.28147 18.5848 7.52493 19.4032 7.52493V10.4549Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_1308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.f3a70ed2e06882db57ea09ed9571242b.svg";
export { ForwardRef as ReactComponent };